<template>
  <div class="login-view">
    <div class="box">
      <div class="brand"><img src="/static/images/pft_front.png" /></div>
      <div class="sign-box">
          <h1>Healthy School Buildings</h1>
          <div class="form-wrapper">
            <div class="form-group">
                <input type="text" class="form-control" v-model="email" placeholder="Email"/>
            </div>
            <div class="form-group">
                <input type="password" class="form-control" v-model="password" placeholder="Password"/>
            </div>
            <button type="submit" class="btn" @click="login">Sign in</button>
          </div>
          <p><router-link :to="{ name: 'passwordreset' }">Forgot Password</router-link></p>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from '@firebase/app'
import '@firebase/auth'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  beforeCreate: function() {
    document.body.classList.add('login')
  },
  beforeDestroy: function() {
    document.body.classList.remove('login')
  },
  mounted () {
    document.body.classList.add('login')    
  },
  methods: {
    login () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          // this.$router.replace('home')
        },
        (error) => {
          alert(error.message)
        }
      )
    }
  }
}
</script>

<style scoped>
.login-view {
  background: #bfb6b7;
}
.box {
  background: white;
  border-radius: 10px;
  margin: 30px 20px 0;
  position: relative;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}
.brand {
  text-align: center;
  position: relative;
  padding: 20px;
}
.brand img {
  position: relative;
  top: 25%;
  max-width: 100%;
}
.sign-box {
  background: #6e5f60;
  color: #fff;
  padding: 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.sign-box h1 {
  padding-top: 0;
}
p a {
  color: white;
  font-weight:bold;
}
p a:hover {
  color: red;
}
.form-group {
  margin: 0 0 20px;
}
.sign-box input {
  border: 0;
  height: 2.5rem;
  font-size: 1rem;
  padding-left: 1rem;
  border-radius: 5px;
  width: 100%;
  display: flex;
  box-sizing: border-box;
}
@media only screen and (min-width: 1028px) {
  .sign-box {
    padding-left: 260px;
  }
  .box {
    width: 960px;
  }
}
@media only screen and (min-width: 680px) {
  .login-view {
    height: 100%;
  }
  .box {
    top: 150px;
    margin: 30px auto 0;
  }
  .brand {
    height: 300px;
  }
  .brand img {
    position: relative;
    top: 25%;
  }
  .sign-box h1 {
    padding-top: 35px;
  }
  .sign-box {
    background: #6e5f60;
    color: #fff;
    height: 200px;
    padding-left: 20%;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .form-wrapper {
    display: flex;
  }
  .form-group {
    margin: 0 25px 0 0;
  }
}

</style>
